var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStreamingIntegration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.9321 36.0114C119.152 36.0114 138.378 36.0284 157.599 36C161.576 35.9944 165.277 36.7822 168.48 39.2535C172.763 42.5523 174.938 46.9848 174.949 52.3525C175 73.7155 175.022 95.0842 174.949 116.447C174.915 125.51 168.288 132.233 159.254 132.698C158.808 132.72 158.356 132.737 157.91 132.737C119.243 132.737 80.5705 132.726 41.9039 132.754C36.0564 132.754 31.3276 130.623 27.8982 125.834C26.0959 123.317 25.0677 120.477 25.062 117.348C25.0394 99.9757 25.0281 82.603 25.0225 65.2304C25.0225 60.5655 24.9603 55.895 25.0846 51.2302C25.2824 43.4196 31.8417 36.6519 39.5762 36.1417C40.8078 36.0624 42.0394 36.017 43.2711 36.017C62.1581 36.0114 81.0451 36.017 99.9321 36.017V36.0114ZM83.9039 84.3602C83.9039 89.4161 83.9378 94.472 83.8869 99.5223C83.8587 102.022 84.5649 104.113 86.9095 105.253C89.1581 106.347 91.2146 105.74 93.1581 104.266C99.8474 99.1879 106.587 94.1659 113.288 89.0987C116.926 86.3497 116.938 82.4387 113.316 79.6953C106.571 74.5884 99.7909 69.5381 93.0507 64.4312C91.0959 62.9518 89.0338 62.419 86.8022 63.5696C84.627 64.6919 83.8813 66.653 83.8982 69.0336C83.9321 74.1463 83.9095 79.2532 83.9095 84.3658L83.9039 84.3602Z",
    fill: "url(#paint0_linear_75_681)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.842 159.616C108.881 159.616 93.9265 159.628 78.9661 159.594C77.7627 159.594 76.9661 159.86 76.1695 160.892C71.87 166.446 63.7005 166.35 59.3503 160.705C58.6723 159.826 58.0056 159.588 56.9887 159.594C48.1356 159.622 39.2825 159.628 30.435 159.594C27.7401 159.588 25.435 157.615 25.0847 155.155C24.6836 152.384 26.1469 149.981 28.7344 149.062C29.452 148.807 30.1638 148.836 30.887 148.83C39.5706 148.83 48.2542 148.813 56.9378 148.841C57.9435 148.841 58.6271 148.649 59.3107 147.753C63.7627 141.921 72.0678 141.966 76.4407 147.855C77.1525 148.813 77.9265 148.836 78.8813 148.836C108.91 148.83 138.938 148.83 168.972 148.836C171.842 148.836 173.847 150.117 174.638 152.429C175.836 155.926 173.333 159.514 169.565 159.594C166.429 159.656 163.288 159.611 160.153 159.611C148.051 159.611 135.949 159.611 123.847 159.611L123.842 159.616Z",
    fill: "url(#paint1_linear_75_681)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_681",
    x1: 100.002,
    y1: 36,
    x2: 100.002,
    y2: 132.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_681",
    x1: 99.9797,
    y1: 143.408,
    x2: 99.9797,
    y2: 164.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 129,
    fill: "white",
    transform: "translate(25 36)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamingIntegration);
export default __webpack_public_path__ + "static/media/Streaming_Integration.015668d561b38769862232648dd0de50.svg";
export { ForwardRef as ReactComponent };